export function formatPhone(phone: string): string {
  const digits = phone.replace(/\D/g, "");
  // Slovenian mobile: 0XX XXX XXX (9 digits starting with 0)
  if (digits.length === 9 && digits.startsWith("0")) {
    return `${digits.slice(0, 3)} ${digits.slice(3, 6)} ${digits.slice(6)}`;
  }
  // International +386: +386 XX XXX XXX
  if (digits.length === 12 && digits.startsWith("386")) {
    return `+386 ${digits.slice(3, 5)} ${digits.slice(5, 8)} ${digits.slice(8)}`;
  }
  return phone;
}
